const renderNode = (map) => (node) => {
  const {
    data: { target },
  } = node
  const factory = map[target?.contentType]
  return factory ? factory(target) : null
}

export default renderNode
